module.exports = __webpack_public_path__ + "img/logo-capstone@3x.11e5ea52.png";